module.exports = __webpack_public_path__ + "static/img/like_1.74797ede.svg";